import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "inhdialog-header" }
const _hoisted_2 = { class: "dialog_name" }
const _hoisted_3 = { class: "dialog_content" }
const _hoisted_4 = { class: "inner_container" }
const _hoisted_5 = { class: "field-group" }
const _hoisted_6 = { class: "field-group__row no-wrap justify-left" }
const _hoisted_7 = { class: "bold-name mr-xs" }
const _hoisted_8 = { class: "field-group" }
const _hoisted_9 = { class: "field-group__row no-wrap justify-left" }
const _hoisted_10 = { class: "bold-name mr-xs" }
const _hoisted_11 = { class: "field-group" }
const _hoisted_12 = { class: "row no-wrap justify-end q-mt-sm q-mr-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_aux_selector = _resolveComponent("aux-selector")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createBlock(_component_q_card, { class: "inhdialog-container" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t("linked_to_client")), 1),
        _createVNode(_component_q_btn, {
          flat: "",
          round: "",
          icon: "close",
          size: "md",
          color: "accent",
          title: _ctx.$t('close_label'),
          onClick: _ctx.close
        }, null, 8, ["title", "onClick"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("linked_to_client")) + ":", 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.currentClientLabel), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("client_for_counterparty")) + ":", 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.newClientLabel), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_aux_selector, {
              "model-type": 27,
              "input-index": 0,
              "allow-multiple": false,
              modelValue: _ctx.tmp_cp_clients,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tmp_cp_clients) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_q_btn, {
              "no-caps": "",
              flat: "",
              label: _ctx.$t('cancel'),
              color: "dark",
              onClick: _ctx.close
            }, null, 8, ["label", "onClick"]),
            _createVNode(_component_q_btn, {
              "no-caps": "",
              class: "q-ml-sm",
              label: _ctx.$t('attach'),
              color: "primary",
              disable: !_ctx.canBind,
              onClick: _withModifiers(_ctx.bind, ["stop"])
            }, null, 8, ["label", "disable", "onClick"])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}